import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

import { useAppSelector, useAppDispatch } from '@/store';
import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';

//import './index.scss';

type TemplateProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const emptyArr: any[] = [];
const emmtyObj: any = {};

const isExpired = (momentumPrize: any) => {
  let prizeExpired = false;
  if (momentumPrize?.bonus_expires_at) {
    const now = new Date().valueOf();
    const prizeExpiresAt = new Date(momentumPrize?.bonus_expires_at).valueOf();
    if (now - prizeExpiresAt > 0) prizeExpired = true;
  }
  return prizeExpired;
};

const Template = (componentProps: TemplateProps) => {
  let props = componentProps;
  let isVisible = true;

  const dataElementContext = React.useContext(DataElementContext);
  [props, isVisible] = processComponentProps(props, dataElementContext);

  const hhRunning = useAppSelector((state) => state.happyHour.running);
  const hhStatuses = useAppSelector((state) => state.happyHour.status);
  const momentumPrize = useAppSelector<any>((state) => state.momentum.prize?.value);
  const momentumPrizeLoaded = useAppSelector<any>((state) => state.momentum?.prize?.loaded);
  const challenges = useAppSelector((state) => state.challenges.challenges);
  const rankGroups = useAppSelector((state) => state.rankSystems.rankGroups);
  const tournamentGroups = useAppSelector<any>((state) =>
    state.tournamentsMissions ? state.tournamentsMissions.groups.list : emptyArr,
  );
  const tournamentGroupsLoaded = useAppSelector<any>((state) =>
    state.tournamentsMissions ? state.tournamentsMissions.groups.loaded : false,
  );
  const calendarStatus = useAppSelector<any>((state) => state.promoCalendar?.calendar?.status ?? null);
  const airtimerStatus = useAppSelector((state) => state.airTimer.status);

  const contextValue = React.useMemo(() => {
    let hasHappyHour = false;
    let hasMomentum = false;
    let hasChallenges = false;

    const isSparkHH = window.config?.useNewHappyHourSystem === '1';

    if (!isSparkHH) {
      if (hhRunning && hhRunning['online-slots'] && hhStatuses && hhStatuses['online-slots']) {
        hasHappyHour = hhRunning && hhRunning['online-slots'] ? hhRunning['online-slots'] : false;
      }
    } else {
      if (hhRunning && hhRunning['CASINO'] && hhStatuses && hhStatuses['CASINO']) {
        hasHappyHour = hhRunning && hhRunning['CASINO'] ? hhRunning['CASINO'] : false;
      }
    }

    hasMomentum = momentumPrizeLoaded && momentumPrize?.active && !isExpired(momentumPrize);

    if (challenges && Array.isArray(challenges) && challenges.length > 0) {
      hasChallenges = true;
    }

    return {
      hasHappyHour: hasHappyHour,
      hasMomentum: hasMomentum,
      hasChallenges: hasChallenges,
      hasRanks: rankGroups && Array.isArray(rankGroups) && rankGroups.length > 0,
      hasTournaments:
        tournamentGroupsLoaded && tournamentGroups && Array.isArray(tournamentGroups) && tournamentGroups.length > 0,
      hasCalendar: !!calendarStatus,
      hasAirTimer: !!airtimerStatus?.status,

      parentContext: dataElementContext,
    };
  }, [
    dataElementContext,
    hhRunning,
    hhStatuses,
    momentumPrize,
    momentumPrizeLoaded,
    challenges,
    rankGroups,
    tournamentGroups,
    tournamentGroupsLoaded,
    calendarStatus,
    airtimerStatus,
  ]);

  if (!isVisible) return null;

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default Template;
